<template>
  <div class="skeleton-wrapper" :class="[type, isDarkMode ? 'dark-skeleton' : 'light-skeleton']">
    <template v-if="type === 'table-row'">
      <div v-for="i in count" :key="i" class="skeleton-row mb-3 p-3">
        <div class="skeleton-col avatar-skeleton me-3"></div>
        <div class="skeleton-col text-skeleton flex-grow-1"></div>
        <div class="skeleton-col float-end ms-3"></div>
      </div>
    </template>
    <template v-else-if="type === 'card'">
      <div v-for="i in count" :key="i" class="skeleton-card card p-4 mb-3">
        <div class="skeleton-title mb-3"></div>
        <div class="skeleton-text"></div>
        <div class="skeleton-text short"></div>
      </div>
    </template>
    <template v-else>
      <div v-for="i in count" :key="i" class="skeleton-text mb-2"></div>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

defineProps({
  type: {
    type: String,
    default: 'text', // 'text', 'table-row', 'card'
  },
  count: {
    type: Number,
    default: 1,
  }
});

const store = useStore();
const isDarkMode = computed(() => store.state.darkMode);
</script>

<style scoped>
/* Base Animations */
@keyframes shimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.skeleton-wrapper {
  width: 100%;
}

/* Light Mode Variables */
.light-skeleton .skeleton-col,
.light-skeleton .skeleton-text,
.light-skeleton .skeleton-title {
  background: #f6f7f8;
  background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
}
.light-skeleton .skeleton-card {
  border: 1px solid #f1f1f1;
}

/* Dark Mode Variables */
.dark-skeleton .skeleton-col,
.dark-skeleton .skeleton-text,
.dark-skeleton .skeleton-title {
  background: #2a2a35;
  background-image: linear-gradient(to right, #2a2a35 0%, #3b3b4a 20%, #2a2a35 40%, #2a2a35 100%);
}
.dark-skeleton .skeleton-card {
  background: #1e1e2f;
  border: 1px solid #2a2a35;
}

/* Geometric Definitions */
.skeleton-col, .skeleton-text, .skeleton-title {
  animation-duration: 1.5s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
  background-repeat: no-repeat;
  background-size: 800px 100%;
  border-radius: 6px;
}

/* Row Specifics */
.skeleton-row {
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
}

.avatar-skeleton {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}

.text-skeleton {
  height: 20px;
}

.float-end {
  width: 100px;
  height: 20px;
}

/* Card Specifics */
.skeleton-card {
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.05); /* very soft shadow */
}

.skeleton-title {
  width: 40%;
  height: 24px;
}

/* Text Specifics */
.skeleton-text {
  width: 100%;
  height: 16px;
  margin-bottom: 8px;
}

.skeleton-text.short {
  width: 60%;
}
</style>
